// Task/Reminder data model
export class Task {
  constructor(data = {}) {
    this.id = data.id || generateId();
    this.title = data.title || '';
    this.description = data.description || '';
    this.type = data.type || 'reminder'; // 'reminder', 'exercise', 'habit'
    this.difficulty = data.difficulty || 1; // 1-5 (easy to hard)
    this.xpReward = data.xpReward || this.calculateXP();
    this.recurring = data.recurring || null; // 'daily', 'weekly', null
    this.completed = data.completed || false;
    this.completedAt = data.completedAt || null;
    this.createdAt = data.createdAt || new Date().toISOString();
    this.dueDate = data.dueDate || null;
    this.goalSource = data.goalSource || null; // 'google-fit' | null
    this.metricType = data.metricType || null; // 'steps' | 'heartRate'
    this.targetValue = Number.isFinite(data.targetValue) ? data.targetValue : null;
    this.metricWindow = data.metricWindow || 'daily'; // 'daily' | 'weekly'
    this.autoComplete = data.autoComplete === true;
    this.lastSatisfiedAt = data.lastSatisfiedAt || null;
  }

  calculateXP() {
    const baseXP = 10;
    const multipliers = {
      1: 1,    // Easy
      2: 1.5,
      3: 2,
      4: 3,
      5: 5     // Hard
    };
    return Math.floor(baseXP * multipliers[this.difficulty]);
  }

  complete() {
    this.completed = true;
    this.completedAt = new Date().toISOString();
    return this.xpReward;
  }

  reset() {
    this.completed = false;
    this.completedAt = null;
  }
}

export class ExerciseTask extends Task {
  constructor(data = {}) {
    super({ ...data, type: 'exercise' });
    this.sets = data.sets || 3;
    this.reps = data.reps || 10;
    this.duration = data.duration || 0; // in seconds
    this.currentProgress = data.currentProgress || 0;
  }

  updateProgress(progress) {
    this.currentProgress = progress;
    if (this.currentProgress >= (this.sets * this.reps)) {
      return this.complete();
    }
    return 0;
  }
}

function generateId() {
  return `task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
